import TreeNode, { TreeNodeProps, TreeNodeVariantStrings } from './TreeNode';

type LineStyle = 'dashed' | 'dotted' | 'double' | 'solid' | string;

export interface TreeProps {
  /** The root label */
  label: TreeNodeProps['label'];
  /** The height of the line */
  lineHeight?: string;
  /** The width of the line */
  lineWidth?: string;
  /** The color of the line */
  lineColor?: string;
  /** The line style for the tree */
  lineStyle?: LineStyle;
  /** The border radius of the line */
  lineBorderRadius?: string;
  /** The padding between siblings */
  nodePadding?: string;
  children: TreeNodeProps['children'];
}

/** The root of the hierarchy tree */
function Tree({ children, label }: TreeProps) {
  return (
    <ul className="orgTree">
      <TreeNode
        label={label}
        variant={TreeNodeVariantStrings.horizontal}
        isLast={true}
      >
        {children}
      </TreeNode>
    </ul>
  );
}

export default Tree;
